import {DATA,COINCHANGE} from '../Actions/Types'

const initialState={
    userData:null
}
export default function (state = initialState,action) {
    switch (action.type) {
        case DATA:
            return {
                ...state,
                userData: action.payload
            }
        case COINCHANGE:
            const {coinType,value,type}=action.payload
            return {
                ...state,
                userData: {
                    ...state.userData,
                    properties: {
                        ...state.userData.properties,
                        [coinType]:
                            type==='increment'?state.userData.properties[coinType]+parseInt(value)
                            :type==='decrement'?state.userData.properties[coinType]-parseInt(value):''
                    }
                }
            }
        default:
            return state
    }
}